import { checkAuthenticated } from '../../actions/AuthenticationActionCreators';

async function refreshAuthentication(nextState) {
  console.info('Refreshing authentication information');
  const context = nextState.routes[0].getContext();
  await context.executeAction(checkAuthenticated, {routes: nextState.routes});

  console.info('Authentication information updated');
  return {};
}

export default refreshAuthentication;



// WEBPACK FOOTER //
// ./src/utils/route/refreshAuthentication.js